module.exports = __webpack_public_path__ + "static/media/Riviera_Level_20.75079c92.jpg";